import { Sidebar as PrimeSidebar } from 'primereact/sidebar'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import NavMenu from '../nav/NavMenu'
import { HOME_PATH } from '../nav/menu'

interface SidebarProps {
  /** Daraltılmış (ikon-ray) mı? */
  collapsed: boolean
  /** Daralt/genişlet tıklaması. */
  onToggle: () => void
}

/**
 * Geniş ekran (masaüstü) kalıcı koyu sidebar — Figma "TK SEYİR" (node 92:0).
 * PrimeReact `Sidebar` bileşeni kalıcı kullanılır: `modal={false}` + her zaman görünür
 * (`visible` sabit `true`); aç/kapa bileşeni gizlemez, genişliği değiştirir (geniş ↔ ikon-ray).
 * İçerik kaydırması (push) `AppLayout`'ta içerik kabının margin'iyle senkronlanır.
 */
export default function Sidebar({ collapsed, onToggle }: Readonly<SidebarProps>) {
  const { t } = useTranslation()
  return (
    <PrimeSidebar
      visible
      onHide={() => {}}
      modal={false}
      dismissable={false}
      showCloseIcon={false}
      blockScroll={false}
      position="left"
      className={`sidebar${collapsed ? ' sidebar--collapsed' : ''}`}
      maskClassName="sidebar-mask"
      aria-label={t('shell.brand.title')}
    >
      <div className="brand">
        <Link to={HOME_PATH} className="brand-logo-link" aria-label={t('shell.home')}>
          {/* Koyu sidebar zemininde siyah metinli logo okunmuyor → beyaz metinli varyant. */}
          <img
            className="brand-logo"
            src={collapsed ? '/tk-logo-mark.png' : '/tk-seyir-logo-light.png'}
            alt={t('shell.brand.title')}
          />
        </Link>
        <div className="brand-right">
          <button
            type="button"
            className="brand-collapse"
            onClick={onToggle}
            aria-label={collapsed ? t('shell.sidebar.expand') : t('shell.sidebar.collapse')}
            aria-expanded={!collapsed}
          >
            {/* Figma daralt/genişlet ikonu (node 179812:2373) — kapalıyken yatay aynalanır. */}
            <svg
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M0.5 15L0.5 0.5" />
              <path d="M9.5 3.5L6.5 7.5L9.5 11.5M6.5 7.5L15.5 7.5" />
            </svg>
          </button>
        </div>
      </div>
      <NavMenu collapsed={collapsed} />
    </PrimeSidebar>
  )
}
